import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Sends a GA4 `page_view` event on every client-side route change.
 * Relies on the gtag.js snippet loaded in /public/index.html.
 */
export default function GA4PageTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    const path = location.pathname + location.search;
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
}
